// ReviewCard.jsx
import React from 'react';
import PropTypes from 'prop-types';
import avatar from '../../assests/avatar.png';
import './Reviewcard.css';

const ReviewCard = ({ review }) => {
  const getTimeSince = (dateString) => {
    const now = new Date();
    const past = new Date(dateString);
    const diffInSeconds = Math.floor((now - past) / 1000);
    
    const intervals = {
      year: 31536000,
      month: 2592000,
      week: 604800,
      day: 86400,
      hour: 3600,
      minute: 60
    };

    for (const [unit, seconds] of Object.entries(intervals)) {
      const value = Math.floor(diffInSeconds / seconds);
      if (value >= 1) {
        if (unit === 'month' && value === 1) {
          return 'A month ago';
        }
        return `${value} ${unit}${value === 1 ? '' : 's'} ago`;
      }
    }
    
    return 'just now';
  };

  const renderStars = (rating) => {
    const stars = [];
    const fullStars = Math.floor(rating);
    const remainder = rating % 1;

    for (let i = 1; i <= 5; i++) {
      if (i <= fullStars) {
        stars.push(
          <span key={i} className="testimonial-star-container">
            <i className="fas fa-star testimonial-star-warning"></i>
          </span>
        );
      } else if (i === fullStars + 1 && remainder > 0) {
        stars.push(
          <span key={i} className="testimonial-star-container position-relative">
            <i className="far fa-star testimonial-star-secondary"></i>
            <div
              className="testimonial-star-fill"
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: `${remainder * 100}%`,
                height: '100%',
                overflow: 'hidden'
              }}
            >
              <i className="fas fa-star testimonial-star-warning"></i>
            </div>
          </span>
        );
      } else {
        stars.push(
          <span key={i} className="testimonial-star-container">
            <i className="far fa-star testimonial-star-secondary"></i>
          </span>
        );
      }
    }
    return stars;
  };

  return (
    <div className="testimonial-slide px-3">
      <div className="testimonial-content">
        {/* Stars and Time Row */}
        <div className="testimonial-header d-flex align-items-start mb-2">
          <div className="testimonial-info">
            {review.rating > 0 && (
              <div className="testimonial-stars d-inline-flex align-items-center">
                {renderStars(review.rating)}
              </div>
            )}
            <span className="testimonial-time ms-2">
              {getTimeSince(review.time)}
            </span>
          </div>
          <img
            src={review.avatar || avatar}
            alt={`${review.name}'s avatar`}
            className="testimonial-avatar rounded-circle ms-auto"
          />
        </div>
        
        {/* Review Text */}
        <p className="testimonial-text">{review.text}</p>
        
        {/* Name */}
        <p className="testimonial-name mb-0">-{review.name}</p>
      </div>
    </div>
  );
};

ReviewCard.propTypes = {
  review: PropTypes.shape({
    name: PropTypes.string.isRequired,
    time: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    avatar: PropTypes.string,
    rating: PropTypes.number
  }).isRequired
};

export default ReviewCard;